import { apiClient } from './api';
import { UserProfile, UserPreferences } from '../types';

export const settingsService = {
  // Get user profile
  getUserProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.get('/api/settings/profile');
    return response.profile;
  },

  // Update user profile
  updateUserProfile: async (profileData: Partial<UserProfile>): Promise<UserProfile> => {
    const response = await apiClient.put('/api/settings/profile', profileData);
    return response.profile;
  },

  // Get user preferences
  getUserPreferences: async (): Promise<UserPreferences> => {
    const response = await apiClient.get('/api/settings/preferences');
    return response.preferences;
  },

  // Update user preferences
  updateUserPreferences: async (preferences: Partial<UserPreferences>): Promise<UserPreferences> => {
    const response = await apiClient.put('/api/settings/preferences', preferences);
    return response.preferences;
  },
}; 